import * as React from 'react'

import { SpinnerSvg } from './spinner'

type ButtonSpinnerVariant = 'default' | 'dark' | 'light'

const ButtonSpinner = ({ variant = 'default' }: { variant?: ButtonSpinnerVariant }) => (
  <span className='button-loading-spinner-container'>
    <SpinnerSvg className={`button-loading-spinner button-loading-spinner--${variant}`} />
  </span>
)

export { ButtonSpinner }
